import { Component, OnInit, ViewChild } from '@angular/core';

import { AppComponent } from 'src/app/app.component';
import { environment } from 'src/environments/environment';

import { JqWidgets } from 'src/app/utils/jqWidgets';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';

import { SsoService } from 'src/app/services/sso/sso.service';

import { TarjetaModel } from 'src/app/services/ciudadanos/models/tarjeta.model';
import { CustomForms } from '../../forms/custom-forms';
import { jqxWindowComponent } from 'jqwidgets-ng/jqxwindow';
import { CiudadanoModel } from 'src/app/services/ciudadanos/models/ciudadano.model';
import { NumberUtils } from 'src/app/utils/number-utils';
import { Utils } from 'src/app/utils/utils';
import { TarjetaListTransformerService } from 'src/app/services/type-list-transformer.service';

@Component({
  selector: 'app-ciudadanos-listado-tarjetas',
  templateUrl: './ciudadanos-listado-tarjetas.component.html',
  styleUrls: ['./ciudadanos-listado-tarjetas.component.css']
})
export class CiudadanosListadoTarjetasComponent extends CustomForms implements OnInit {
  @ViewChild('form') form: jqxWindowComponent;
  @ViewChild('gridTarjetas') gridTarjetas: jqxGridComponent;

  private componentRef = null;
  public theme = environment.tema;
  public environment = environment;
  public langGrid = JqWidgets.getLocalization('es');

  public onCerrar?: () => void;

  tarjetas: TarjetaModel[] = [];
  ciudadano;


  cellClass = (row: number, columnfield: any, value: any): string => {
    if (value) {
      return 'cellTooltip';
    }
    return '';
  };

  public columnsTarjetas = [
    {
      text: this.translate('Tipo'),filtertype: 'checkedlist', columntype: 'textbox', datafield: 'typeLabel', width: 80,
      aggregates: [{
        'Total': function (aggregatedValue, currentValue: number) {
          return aggregatedValue + 1;
        }
      }],
      aggregatesrenderer: function (aggregates) {
        let renderstring = '';
        if (aggregates["Total"] !== undefined) {
          renderstring = '<div style="text-align: left; margin-left: 4px;">' + AppComponent.translate('Total') + ': ' +
            NumberUtils.format(aggregates["Total"], 0) + '</div>';
        }
        return renderstring;
      },
    },
    { text: this.translate('Ns_movisat'), columntype: 'textbox', datafield: 'nsMovisat', editable: false, width: 140 },
    { text: this.translate('Descripcion'), columntype: 'textbox', datafield: 'descripcion', editable: false, width: 100 },
    { text: this.translate('Lista_tipo'), columntype: 'textbox',filtertype: 'checkedlist', datafield: 'listTypeLabel', width: 90 },
    { text: this.translate('Direccion'), columntype: 'textbox', filtertype: 'textbox', datafield: 'calle', width: 100, cellclassname: this.cellClass },
    { text: this.translate('Poblacion'), columntype: 'textbox', filtertype: 'checkedlist', datafield: 'poblacion', width: 100, cellclassname: this.cellClass },
    { text: this.translate('Municipio'), columntype: 'textbox', filtertype: 'checkedlist', datafield: 'municipio', width: 100, cellclassname: this.cellClass },
    { text: this.translate('Codigo_postal'), columntype: 'textbox', filtertype: 'textbox', datafield: 'codigoPostal', width: 60, cellclassname: this.cellClass },
    { text: this.translate('Provincia'), columntype: 'textbox', filtertype: 'checkedlist', datafield: 'provincia', width: 100, cellclassname: this.cellClass },
    { text: this.translate('Comunidad_autonoma'), columntype: 'textbox', filtertype: 'checkedlist', datafield: 'comunidadAutonoma', width: 100, cellclassname: this.cellClass },
  ];

  public sourceTarjetas = {
    datatype: 'json',
    datafields: [
      { name: 'nsMovisat', type: 'string', map: 'nsMovisat' },
      { name: 'descripcion', type: 'string', map: 'descripcion' },
      { name: 'typeLabel', type: 'string' },
      { name: 'listTypeLabel', type: 'string' },
      { name: 'calle', map: 'direccion>direccion', type: 'string' },
      { name: 'codigoPostal', map: 'direccion>codigoPostal', type: 'string' },
      { name: 'comunidadAutonoma', map: 'direccion>comunidadAutonoma' },
      { name: 'municipio', map: 'direccion>municipio' },
      { name: 'numeroCalle', map: 'direccion>numero', type: 'number' },
      { name: 'poblacion', map: 'direccion>poblacion' },
      { name: 'provincia', map: 'direccion>provincia' },
      { name: 'selec', map: 'selec' }
    ],
    localdata: this.tarjetas
  };

  public dataAdapterTarjetas = new jqx.dataAdapter(this.sourceTarjetas);

  public translate(text: string): string {
    return AppComponent.translate(text);
  }

  constructor(private ssoService: SsoService, private tarjetaTransformer: TarjetaListTransformerService) {
    super();
  }

  public init(componentRef: any, ciudadano: CiudadanoModel): void {
    this.componentRef = componentRef;
    this.ciudadano = ciudadano;
    this.tarjetas = ciudadano.tarjetas?.map(tarjeta => {
      if (tarjeta.direccion) {
        tarjeta.direccion.direccion = this.formatearDireccion(tarjeta.direccion);
      }

      return this.tarjetaTransformer.transform(tarjeta);
    }) ?? [];
    this.sourceTarjetas.localdata = this.tarjetas;
    this.dataAdapterTarjetas.dataBind();
  }

  private formatearDireccion(direccion: { direccion: string; numero?: string }): string {
    if (!direccion?.direccion) return;
    return direccion.numero?.trim() ? `${direccion.direccion}, ${direccion.numero}` : direccion.direccion;
  }

  async ngAfterViewInit(): Promise<void> {
    this.form.setTitle(this.translate('Tarjetas') + ' ' + this.ciudadano.nombre + ' ' + this.ciudadano.apellidos);
    this.addCustomForm(this.form);
  }

  ngOnInit(): void {
    this.langGrid = JqWidgets.getLocalization(this.ssoService.getTicket().Usuario.Idioma.Codigo.substring(0, 2));
  }

  public onClose(): void {
    if (this.onCerrar) {
      this.onCerrar();
    }

    if (this.componentRef) {
      this.componentRef.destroy();
    }
  }

  closeWindow() {
    this.form.close();
  }

  updatefilterconditions = (type: string, defaultconditions: any): string[] => {
    return Utils.updatefilterconditions(type, defaultconditions);
  };

  public filter(cellValue?: any, rowData?: any, dataField?: string, filterGroup?: any, defaultFilterResult?: boolean): any {
    let filterColumns = [
      'nsMovisat',
      'descripcion',
    ]

    return Utils.filterRow(cellValue, dataField, filterGroup, defaultFilterResult, filterColumns);
  }
}
